'use client';

import React, { useState } from 'react';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { useAuthStore } from '@/stores/userStore';
import { userUIStore } from '@/stores/userUIStore';

import { normalizeImageUrl } from '@/utils/core';

import { GameItem } from '@/interfaces/core';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';

import { useAuth } from '@/core/auth/client/AuthProvider';
import { handleLoginModal } from '../casino/utils';
import AcceptModal from '../modals/AcceptModal';

interface RecommendedGamesCarouselProps {
  games: GameItem[];
}

export default function RecommendedGamesCarousel({ games }: RecommendedGamesCarouselProps) {
  const [isAcceptModalUrl, setIsAcceptModalUrl] = useState<string>('');
  const router = useRouter();
  const { session } = useAuth();
  const { balance, account } = useAuthStore();
  const {
    toggleLoginModal, toggleDepositModal, toggleDepositSheet, toggleAcceptModal,
  } = userUIStore();

  const handleLoginModalProps = {
    session,
    balance,
    account,
    toggleLoginModal,
    toggleDepositModal,
    toggleDepositSheet,
    toggleAcceptModal,
    setIsAcceptModalUrl,
    router,
  };

  return (
    <div className="w-full bg-gray-900 py-4">
      <div className="max-w-[1536px] mx-auto px-4">
        <Carousel
          className="w-full"
          opts={{
            align: 'start',
          }}
        >
          <CarouselContent className="-ml-1 md:-ml-2">
            {games?.map((game, index) => {
              const imageUrl = normalizeImageUrl(game.thumb_url);
              return (
                <CarouselItem key={game.identifier} className="pl-1 md:pl-2 basis-1/3 md:basis-1/3 lg:basis-1/3 min-[1280px]:basis-1/6">
                  <div className="p-1">
                    <Card className="bg-transparent border-none overflow-hidden">
                      <CardContent className="p-0">
                        <div
                          className="aspect-square w-full flex items-center justify-center relative group hover:opacity-75"
                        >
                          <Image
                            src={imageUrl}
                            alt={game.title}
                            width={200}
                            height={0}
                            className="w-full rounded-xl h-full cursor-pointer transition duration-300 ease-in-out hover:opacity-55"
                          />
                          <div className="flex absolute top-[5px] right-1 w-fit rounded-sm overflow-hidden shadow-xs shadow-black">
                            {game.sections?.nuevos && (
                              <span className="text-sivarbet-border md:text-xs text-[10px] bg-green-500 md:px-2 p-0.5 md:font-semibold">
                                Nuevo
                              </span>
                            )}
                            {game.sections?.popular && (
                              <span className="text-sivarbet-border md:text-xs text-[10px] bg-yellow-500 md:px-2 p-0.5 md:font-semibold">Popular</span>
                            )}
                            {game.sections?.recomendados && (
                              <span className="text-sivarbet-border md:text-xs text-[10px] bg-red-600 md:px-2 p-0.5 md:font-semibold">Top</span>
                            )}
                          </div>
                          <Button
                            type="button"
                            className="hidden absolute hover:text-black bg-[radial-gradient(circle,rgb(236,4,140)_100%,rgb(255,26,155)_100%)] text-white sm:px-4 sm:py-2 text-sm md:text-base lg:text-lg group-hover:block group opacity-200!"
                            onClick={() => {
                              handleLoginModal({
                                ...handleLoginModalProps, item: game, categorySelected: 'recomendados', gameIndex: index,
                              });
                            }}
                          >
                            Jugar
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CarouselPrevious className="absolute -left-4 top-1/2 -translate-y-1/2 bg-gray-800 hover:bg-gray-800 text-white border border-gray-800 fill-white" />
          <CarouselNext className="absolute -right-4 top-1/2 -translate-y-1/2 bg-gray-800 hover:bg-gray-800 text-white border border-gray-800 fill-white" />

        </Carousel>
        {/* <div className="flex flex-col items-center mt-4">
          <Button
            className="hover:text-black bg-[radial-gradient(circle,rgb(236,4,140)_100%,rgb(255,26,155)_100%)] text-black group-hover:block font-semibold group opacity-200! py-2 px-6"
            onClick={() => { return router.push('/casino'); }}
          >
            Ver Mas Juegos
          </Button>
        </div> */}
      </div>
      <AcceptModal url={isAcceptModalUrl} />
    </div>
  );
}
